<template>
  <footer id="footer">
    <div class="container">
      <div class="footer-navigation">
        <ul class="tnc-wrapper">
          <li>
            <router-link to="/termsofuse" @click.native="on('/termsofuse')">{{$t('footer.terms')}}</router-link>
          </li>
          <li>
            <router-link to="/privacypolicy" @click.native="on('/privacypolicy')">{{$t('footer.privacy')}}</router-link>
          </li>
          <!-- <li>
            <router-link to="/cookie">Cookie Policy</router-link>
          </li> -->
        </ul>
        <ol class="tnc-wrapper-right">
          <li><a class="iconfont" href="http://www.facebook.com/audihk" target="_blank" title="Audi on Facebook">&#xe601;</a></li>
          <li><a class="iconfont" href="https://www.youtube.com/channel/UCUQhy03y9G4WoAVriDQOyiw" target="_blank" title="YouTube">&#xe7af;</a></li>
          <li><a class="iconfont" href="https://www.instagram.com/audihk/" target="_blank" title="Instagram">&#xe600;</a></li>
        </ol>
      </div>
      <div class="copyright">
        <p class="copy" v-html="$t('footer.copy')"></p>
      </div>
    </div>
  </footer>
</template>

<script>
import PubSub from 'pubsub-js'

export default {
  name: "Footer",
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    on(url) {
      // 发布消息
      PubSub.publish('on', {url: url, on: 'on'})
    }
  },
  watch:{
  }
}
</script>

<style lang="stylus" ref="stylesheet/stylus" scoped>
/* footer */
#footer {
  background-color: #4c4c4c;
  color: #fff;
  height: auto;
  width: 100%;
}

#footer .tnc-wrapper,
#footer .tnc-wrapper-right {
  float: left;
  height: 50px;
  line-height: 50px;
  list-style: none;
  padding: 0;
  margin: 0;
}

#footer .tnc-wrapper li {
  float: left;
}

#footer .tnc-wrapper li a {
  // border-right: 1px solid #fff;
  font-family: 'AudiTypeExtendedNormal';
  font-size: 14px;
  margin-right: 20px;
  color: #fff;
  text-decoration: none;
}

#footer .tnc-wrapper li:last-child a {
  border-right: 0;
}

#footer .tnc-wrapper-right {
  float: right;
  li {
    float: left;
    a {
      display: block;
      font-size: 30px;
      padding: 0 14px;
      color: #fff;
      text-decoration: none;
    }
  }
}

#footer .footer-navigation {
  overflow: hidden;
  padding-top: 26px; 
  padding-bottom: 20px; 
}

#footer .copyright {
  border-top: 1px solid #666;
  color: #999;
  padding-top: 18px;
  padding-bottom: 50px;
}

#footer .copy {
  font-size: 12px;
}

@media (max-width: 767px) {
  /*footer*/
  #footer {
      height: auto;
  }
  #footer #facebook-btn,
  #footer #youtube-btn {
      margin-bottom: 10px;
  }
  #footer .tnc-wrapper{
      width: 100%;
      height: auto;
      line-height: 32px;
      overflow: hidden;
  }
  #footer .tnc-wrapper {
      margin-bottom: 10px;
  }
  #footer .copyright {
    padding-bottom: 20px;
  }
  #footer .tnc-wrapper {
    width: 100%;
    float: none;
  }
  #footer .tnc-wrapper-right {
    width: 100%;
    float: none;
    li {
      float: left;
      a {
        display: block;
        font-size: 28px;
        padding: 0 14px;
        color: #fff;
        text-decoration: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue